#@import GliveBooking.Presenters.Book
#@export GliveBooking.Views.Book

class GliveBooking.Views.Book extends BookingV2.Views.Base

  module: 'glive-booking'

  initialize: ->
    unless @_isTouchRequest()
      _.defer(@_setupTooltip, this)

  presenter: GliveBooking.Presenters.Book

  templateName: 'book'

  attributes: ->
    'data-bhw': "#{GliveBooking.bhw}BookButton"

  _isTouchRequest: ->
    @model?.get("isTouchRequest")

  _setupTooltip: (book) ->
    GIG.Tooltip.reloadBindings(element=document.body)
    book._disableButton()
    book._moveTooltipToRoot()

  _disableButton: ->
    $(@el).find("button.disabled").click (e) ->
      e.preventDefault()

  _moveTooltipToRoot: ->
    if @_tooltip().parent()[0] isnt document.body
      $(document.body).append @_tooltip()

  _tooltip: ->
    $(@el).find("#" + @_tooltipId())

  _tooltipId: _.memoize ->
    $(@el).find("button").data("tooltip-id")
